import React from "react";
import "./unread-icon.scss";

export const UnreadIcon = React.memo(({children, color}) => {
    return (
        <div className={`unread-icon-ui ${color ? `unread-${color}` : ''}`}>
            <span>{children}</span>
        </div>
    )
})